import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { MedicalService } from './medical-service';
import { requestHeaders } from '../shared/api.service';

const camelcaseKeysDeep = require('camelcase-keys-deep');

@Injectable()
export class MedicalServiceService {
  baseUrl = environment.serverUrl;

  constructor(
    private http: Http
  ) { }

  getMedicalService(medicalServiceId) {
    let medicalServicesUrl = this.baseUrl + 'nurse_visits/services/' + medicalServiceId + '/';

    return this.http.get(medicalServicesUrl, { headers: requestHeaders() })
      .map(this.extractData);
  }

  getMedicalServices(query: any = null): Observable<MedicalService[]> {
    let medicalServicesUrl = this.baseUrl + 'nurse_visits/services/';
    let params: URLSearchParams = new URLSearchParams();

    if (query) {
      Object.keys(query).forEach((key) => {
        if (typeof query[key] !== 'undefined' && query[key] && query[key].toString) {
          params.set(key, query[key].toString());
        }
      });
    }
    params.set('sf', 'code,name');

    return this.http.get(medicalServicesUrl, {
      headers: requestHeaders(),
      search: params
    }).map(this.extractData);
  }

  private extractData(res: Response) {
    let body = res.json().results;
    if (body) {
      return body.map(medicalService => {
        medicalService = camelcaseKeysDeep(medicalService);
        return new MedicalService(medicalService);
      });
    } else if (res.json()) {
      let medicalService = camelcaseKeysDeep(res.json());
      if (medicalService instanceof Array) {
        return medicalService.map(_medicalService => {
          _medicalService = camelcaseKeysDeep(_medicalService);
          return new MedicalService(_medicalService);
        });
      } else {
        return new MedicalService(medicalService);
      }
    } else {
      return [];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/medical-services/medical-service.service.ts